import { FormGroup } from '@angular/forms'
import { Message } from '../config/message';
export class Validation {

	myForm: FormGroup;
	msg: Message;
	constructor() {
		this.msg = new Message();
	}

	//validacion si es numero
	//Keycode == 46 verifica si es punto
	validationNumber(event) {
		var keycode = event.charCode;
		if (!(event.shiftKey == false && 
				(
					event.keyCode == 8 ||event.keyCode == 9 
					||event.keyCode == 36 ||event.keyCode == 35 
					||event.keyCode == 37 || event.keyCode == 39
				)
				||( keycode >= 48 && keycode <= 57 ) || keycode === 46 || keycode === 118 ) ) {
			event.preventDefault();
		}
	}

	validationInteger(event) {
		var keycode = event.charCode;
		if (!(event.shiftKey == false && 
				(
					event.keyCode == 8 ||event.keyCode == 9 
					||event.keyCode == 36 ||event.keyCode == 35 
					||event.keyCode == 37 || event.keyCode == 39
				)
				||( keycode >= 48 && keycode <= 57 ) || keycode === 118 ) ) {
			event.preventDefault();
		}
	}

	decimalNumber(event){
		const regex: RegExp = new RegExp(/^\d+[.,]?\d{0,6}$/g);// user can put . or , char.
		// input also cannot start from , or .
		const specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
		if (specialKeys.includes(event.key)) {
			return;
		}
		const current: string = event.target.value;
		const position = event.target.selectionStart;
		const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
		if (next && !String(next).match(regex)) {
			event.preventDefault();
		}
	}

	//Validacion para mostrar la etiqueta que contiene el mensaje
	validErrorForm(campo, myForm) {
		return myForm.get(campo).errors && myForm.get(campo).dirty;
	}

	//Validacion para mostrar el tipo de mensaje
	validTypeMsgForm(nombre, campo, myForm) {
		let iCampo = myForm.get(campo);
		if (iCampo.hasError('required'))
			return this.msg.required;
		if (iCampo.hasError('pattern'))
			return nombre + " " + this.msg.pattern;
		if (iCampo.hasError('email'))
			return nombre + " " + this.msg.email;
		if (iCampo.hasError('minlength')) {
			return nombre + " requiere " + this.msg.min + " " + iCampo.errors.minlength.requiredLength + " caracteres";
		}
		if (iCampo.hasError('maxlength')) {
			return nombre + " requiere " + this.msg.max + " " + iCampo.errors.maxlength.requiredLength + " caracteres";
		}
	}

	validDate(fecha) {
		var dtCh = "/";
		var minYear = 1900;
		var maxYear = 2100;

		function isInteger(s) {
			var i;
			for (i = 0; i < s.length; i++) {
				var c = s.charAt(i);
				if (((c < "0") || (c > "9"))) return false;
			}
			return true;
		}
		function stripCharsInBag(s, bag) {
			var i;
			var returnString = "";
			for (i = 0; i < s.length; i++) {
				var c = s.charAt(i);
				if (bag.indexOf(c) == -1) returnString += c;
			}
			return returnString;
		}
		function daysInFebruary(year) {
			return (((year % 4 == 0) && ((!(year % 100 == 0)) || (year % 400 == 0))) ? 29 : 28);
		}
		function DaysArray(n) {
			var num = [];
			for (var i = 1; i <= n; i++) {
				num[i] = 31;
				if (i == 4 || i == 6 || i == 9 || i == 11) { num[i] = 30 }
				if (i == 2) { num[i] = 29 }
			}
			return num;
		}
		function isDate(dtStr) {
			var daysInMonth = DaysArray(12)
			var pos1 = dtStr.indexOf(dtCh)
			var pos2 = dtStr.indexOf(dtCh, pos1 + 1)
			var strDay = dtStr.substring(0, pos1)
			var strMonth = dtStr.substring(pos1 + 1, pos2)
			var strYear = dtStr.substring(pos2 + 1)
			let strYr = strYear
			if (strDay.charAt(0) == "0" && strDay.length > 1) strDay = strDay.substring(1)
			if (strMonth.charAt(0) == "0" && strMonth.length > 1) strMonth = strMonth.substring(1)
			for (var i = 1; i <= 3; i++) {
				if (strYr.charAt(0) == "0" && strYr.length > 1) strYr = strYr.substring(1)
			}
			let month = parseInt(strMonth)
			let day = parseInt(strDay)
			let year = parseInt(strYr)
			if (pos1 == -1 || pos2 == -1) {
				return false
			}
			if (strMonth.length < 1 || month < 1 || month > 12) {
				return false
			}
			if (strDay.length < 1 || day < 1 || day > 31 || (month == 2 && day > daysInFebruary(year)) || day > daysInMonth[month]) {
				return false
			}
			if (strYear.length != 4 || year == 0 || year < minYear || year > maxYear) {
				return false
			}
			if (dtStr.indexOf(dtCh, pos2 + 1) != -1 || isInteger(stripCharsInBag(dtStr, dtCh)) == false) {
				return false
			}
			return true
		}
		if (isDate(fecha)) {
			return true;
		} else {
			return false;
		}

	}

	validDateYYYY(fecha) {
		var dtCh = "-";
		var minYear = 1900;
		var maxYear = 2100;

		function isInteger(s) {
			var i;
			for (i = 0; i < s.length; i++) {
				var c = s.charAt(i);
				if (((c < "0") || (c > "9"))) return false;
			}
			return true;
		}
		function stripCharsInBag(s, bag) {
			var i;
			var returnString = "";
			for (i = 0; i < s.length; i++) {
				var c = s.charAt(i);
				if (bag.indexOf(c) == -1) returnString += c;
			}
			return returnString;
		}
		function daysInFebruary(year) {
			return (((year % 4 == 0) && ((!(year % 100 == 0)) || (year % 400 == 0))) ? 29 : 28);
		}
		function DaysArray(n) {
			var num = [];
			for (var i = 1; i <= n; i++) {
				num[i] = 31;
				if (i == 4 || i == 6 || i == 9 || i == 11) { num[i] = 30 }
				if (i == 2) { num[i] = 29 }
			}
			return num;
		}
		function isDate(dtStr) {
			var daysInMonth = DaysArray(12)
			var pos1 = dtStr.indexOf(dtCh)
			var pos2 = dtStr.indexOf(dtCh, pos1 + 1)
			var strYear = dtStr.substring(0, pos1)
			var strMonth = dtStr.substring(pos1 + 1, pos2)
			var strDay = dtStr.substring(pos2 + 1)
			let strYr = strYear
			if (strDay.charAt(0) == "0" && strDay.length > 1) strDay = strDay.substring(1)
			if (strMonth.charAt(0) == "0" && strMonth.length > 1) strMonth = strMonth.substring(1)
			for (var i = 1; i <= 3; i++) {
				if (strYr.charAt(0) == "0" && strYr.length > 1) strYr = strYr.substring(1)
			}
			let month = parseInt(strMonth)
			let day = parseInt(strDay)
			let year = parseInt(strYr)
			if (pos1 == -1 || pos2 == -1) {
				return false
			}
			if (strMonth.length < 1 || month < 1 || month > 12) {
				return false
			}
			if (strDay.length < 1 || day < 1 || day > 31 || (month == 2 && day > daysInFebruary(year)) || day > daysInMonth[month]) {
				return false
			}
			if (strYear.length != 4 || year == 0 || year < minYear || year > maxYear) {
				return false
			}
			if (dtStr.indexOf(dtCh, pos2 + 1) != -1 || isInteger(stripCharsInBag(dtStr, dtCh)) == false) {
				return false
			}
			return true
		}
		if (isDate(fecha)) {
			return true;
		} else {
			return false;
		}

	}

	validCI(cedula){
        var cad = cedula;
        var total = 0;
        var longitud = cad.length;
        var longcheck = longitud - 1;

        if (cad !== "" && longitud === 10){
          for(let i = 0; i < longcheck; i++){
            if (i%2 === 0) {
              var aux = parseInt(cad.charAt(i)) * 2;
              if (aux > 9) aux -= 9;
              total += aux;
            } else {
              total += parseInt(cad.charAt(i)); // parseInt o concatenará en lugar de sumar
            }
          }

          total = total % 10 ? 10 - total % 10 : 0;

          if (parseInt(cad.charAt(longitud - 1)) == total) {
            return true;
          }else{
            return false;
          }
        }
    }

    validRUC(RUC){
        if( RUC.length < 13 ) return false;

        let cedula = RUC.substring(0,10);
        let digitos = RUC.substring(10,13);

        if( digitos != "001" ) return false;
        
        return this.validCI(cedula);
	}	

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/config/validation.ts